import { useQuery } from "react-query";
import axios from "infra/http";

function useClassificacaoTributarias() {
  return useQuery(
    "/v1/classificacao-tributaria",
    async (): Promise<{ nome: string; id: string }[]> => {
      const res = await axios.get("/v1/classificacao-tributaria");

      return res.data;
    }
  );
}

export default useClassificacaoTributarias;
